"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _Organization = _interopRequireDefault(require("../factories/Organization.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_Organization.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.USER_SUBSCRIPTIONS_FETCHED] = stateHelper.resetAndSet;
reducers[_constants.SESSION_FETCHED] = stateHelper.resetAndSet;
reducers[_constants.ORGANIZATION_FETCHED] = stateHelper.set;
reducers[_constants.ORGANIZATIONS_FETCHED] = stateHelper.update;
reducers[_constants.ORGANIZATION_MEMBERS_PAGINATED] = function (state, payload) {
  return state.setIn([payload.organizationId, 'has_more_members_pagination'], payload.hasMoreMembersPagination);
};
reducers[_constants.MEMBER_GROUPS_PAGINATED] = function (state, payload) {
  return state.setIn([payload.organizationId, 'has_more_member_groups_pagination'], payload.hasMoreMemberGroupsPagination);
};
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.ORGANIZATION_UNLOAD_MEMBER_GROUPS] = function (state, payload) {
  return state.setIn([payload.organizationId, 'has_more_member_groups_pagination'], true);
};
var _default = exports.default = stateHelper.createReducer(reducers);